
<div mat-dialog-title>
  External Account Created
  <button class="close" mat-button title="Cancel" (click)="close()">
    <i class="material-icons clear">clear</i>
  </button>
</div>
<mat-dialog-content>
  <div class="external-accounts-complete">
    <p class="label"><span class="bold"> External account number:</span> {{ mdd.accountDetails.accountNumber }}</p>
    <p>
      Next you'll need to go to the Edit Account screen to add account details.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div>
    <button class="btn-medium-secondary" (click)="close()">
      Close - I'll do this later
    </button>
    <button class="btn-medium-primary" (click)="gotoAccountDetails()">
      Go to account details
    </button>
  </div>
</mat-dialog-actions>
